<template>
  <div
    style="padding: 24px"
    class="big"
  >
    <div style="border: solid 1px #c9cbd6">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%; min-width: 1000px"
        :header-cell-style="{ background: '#F5F5F5' }"
      >
        <el-table-column
          label="生成时间"
          prop="create_time"
        ></el-table-column>
        <el-table-column
          label="用户昵称"
          prop="nick_name"
        ></el-table-column>
        <el-table-column
          label="处方总金额"
          prop="total_price"
        ></el-table-column>
        <el-table-column
          label="处方数量"
          prop="total_num"
        ></el-table-column>
        <el-table-column
          label="交易流水号"
          prop="trade_no"
        ></el-table-column>
        <el-table-column
          label="转账备注"
          prop="remark"
        ></el-table-column>
        <el-table-column
          label="收货人"
          prop="consignee_name"
        ></el-table-column>
        <el-table-column
          label="手机号"
          prop="consignee_phone"
        ></el-table-column>
        <el-table-column
          label="所在地区"
          prop="remark"
        >
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.address_info.province_name }}</span>
              <span>{{ scope.row.address_info.city_name }}</span>
              <span>{{ scope.row.address_info.district_name }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          width="160"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="toDetail(scope.row.accounts_id)"
            >查看处方</el-button>
            <el-button
              type="text"
              @click="passLog(scope.row.accounts_id)"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('478') : false
              "
            >通过</el-button>
            <el-button
              type="text"
              @click="refuse(scope.row.accounts_id)"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('479') : false
              "
            >驳回</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 24px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import platform from '../../../api/platform';
export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取处方列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        status: 2
      };
      this.axios
        .post('platform/prescription/getPrescriptionAccountsList', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.create_time = platform.timestampToTime(item.create_time);
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    //通过
    passLog(accounts_id) {
      this.$confirm(
        '您是否已核对交易流水号？确定后，将批量生成订单。',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
      )
        .then(() => {
          let loading = this.$loading();
          this.axios
            .post('platform/prescription/surePrescriptionAccounts', {
              accounts_id
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('记录已通过');
                this.getList();
                loading.close();
              }
            })
            .catch(() => {
              loading.close();
            });
        })
        .catch(() => {});
    },
    //驳回
    refuse(accounts_id) {
      this.$prompt('请输入原因', '驳回', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(({ value }) => {
          let data = {
            accounts_id,
            refund_desc: value
          };
          this.axios
            .post('platform/prescription/refundPrescriptionAccounts', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('记录已驳回');
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //查看详情
    toDetail(accounts_id) {
      this.$router.push({
        path: 'accountsdetail',
        query: {
          accounts_id
        }
      });
    }
  },
  created() {
    this.getList();
  },
  activated() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.mydivider {
  margin: 0;
}

.btnbox {
  text-align: left;
  margin: 20px 0;
  padding-left: 14px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;
  .item {
    margin-right: 30px;
    margin-top: 24px;
  }
}
</style>
